import { ActionTypes } from "store/constants";

export const setListWorkSheet = (data) => ({
  type: ActionTypes.worksheet.set_worksheet_list,
  payload: data,
});

export const updateQuestionBank = (data) => ({
  type: ActionTypes.worksheet.update_worksheet_list,
  payload: data,
});

export const deleteQuestionByID = (data) => ({
  type: ActionTypes.worksheet.delete_question_by_id,
  payload: data,
});

export const updateWorksheetImage = (data) => ({
  type: ActionTypes.worksheet.update_worksheet_image,
  payload: data,
});

export const updateWorksheetName = (data) => ({
  type: ActionTypes.worksheet.update_worksheet_image_success,
  payload: data,
});